import { getUserId } from "App/services/idpTokenService";
import { VEROnfidoToken, VERPersonaToken, VERPutRelevantIdInfoRequest, VERUserVerificationStatus } from "Shared/models/swagger/ver";
import { APIResponse, MS_API } from "Shared/services/apiInterface";

enum UserVerificationURIs {
  BaseApi         = '/v1/users',
  BaseApiV2       = '/v2/users',
  StatusApi       = '/status',
  OnfidoTokenApi  = '/onfido/token',
  OnfidoChecksApi = '/onfido/checks',
  RelevantIdApi   = '/rvid',
  PersonaTokenApi = '/persona/token'
}

/**
 *
 * @returns {Promise<AxiosResponse>}
 */
const getUserVerificationStatus = (): Promise<APIResponse<VERUserVerificationStatus>> => {
  const userId = getUserId();

  return MS_API({
    method : 'GET',
    baseURL: process.env.REACT_APP_VER_BASE_URL,
    url    : `${UserVerificationURIs.BaseApiV2}/${userId}${UserVerificationURIs.StatusApi}`
  });
};

/**
 *
 * @returns {Promise<AxiosResponse>}
 */
const getUserVerificationOnfidoToken = (): Promise<APIResponse<VEROnfidoToken>> => {
  const userId = getUserId();

  return MS_API({
    method : 'GET',
    baseURL: process.env.REACT_APP_VER_BASE_URL,
    url    : `${UserVerificationURIs.BaseApi}/${userId}${UserVerificationURIs.OnfidoTokenApi}`
  });
};

/**
 * Get Persona token (inquiry-id) for Persona verification redirect
 * @returns {Promise<AxiosResponse>}
 */
const getUserVerificationPersonaToken = (): Promise<APIResponse<VERPersonaToken>> => {
  const userId = getUserId();

  return MS_API({
    method : 'GET',
    baseURL: process.env.REACT_APP_VER_BASE_URL,
    url    : `${UserVerificationURIs.BaseApi}/${userId}${UserVerificationURIs.PersonaTokenApi}`
  });
};

/**
 *
 * @returns {Promise<AxiosResponse>}
 */
const postUserVerificationOnfidoChecks = (): Promise<APIResponse<void>> => {
  const userId = getUserId();

  return MS_API({
    method : 'POST',
    baseURL: process.env.REACT_APP_VER_BASE_URL,
    url    : `${UserVerificationURIs.BaseApi}/${userId}${UserVerificationURIs.OnfidoChecksApi}`,
    data   : {
      feature: "MOTION" // This is a hardcoded value that needs to be passed to the API when we added the motion in Onfido config
    }
  });
};

/**
 * Sends the verification answers received from Relevant Id
 */
const putRelevantIdVerificationStatus = (data: VERPutRelevantIdInfoRequest): Promise<APIResponse> => {
  const userId = getUserId();

  return MS_API({
    method : 'PUT',
    baseURL: process.env.REACT_APP_VER_BASE_URL,
    url    : `${UserVerificationURIs.BaseApi}/${userId}${UserVerificationURIs.RelevantIdApi}`,
    data   : data
  });
};

export {
  getUserVerificationOnfidoToken,
  getUserVerificationPersonaToken,
  getUserVerificationStatus,
  postUserVerificationOnfidoChecks,
  putRelevantIdVerificationStatus,
  UserVerificationURIs
};